'use client';

import {
  BodyLinkV3,
  InverseHeader,
  LayoutGrid,
  TypographyV3,
  useHeaderContext,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

const Content = (): JSX.Element => {
  const t = useTranslations();
  const { setInverse } = useHeaderContext()!;

  useEffect(() => {
    setInverse(true);
    return () => setInverse(true);
  }, [setInverse]);

  return (
    <>
      <InverseHeader enter>
        <div className="py-24">
          <LayoutGrid>
            <TypographyV3
              variant="h2"
              Element="h1"
              color="light"
              className="col-main"
            >
              {t('contact_title')}
            </TypographyV3>
          </LayoutGrid>
        </div>
      </InverseHeader>
      <LayoutGrid className="gap-y-8 bg-white py-16">
        <div className="col-main lg:col-end-12">
          <TypographyV3 variant="h4" Element="h2">
            {t('contact_section_1_heading')}
          </TypographyV3>
        </div>

        <div className="col-main lg:col-start-13 lg:col-end-main">
          <div className="mb-8">
            <TypographyV3 variant="h5" Element="h3">
              {t('contact_customer_support_title')}
            </TypographyV3>

            <TypographyV3>
              {t.rich('contact_customer_support_body', {
                a(chunks) {
                  return (
                    <BodyLinkV3
                      href="https://support.ouraring.com/hc/"
                      target="_blank"
                    >
                      {chunks}
                    </BodyLinkV3>
                  );
                },
              })}
            </TypographyV3>
          </div>

          <TypographyV3 variant="h5" Element="h3">
            {t('contact_brand_partnership_title')}
          </TypographyV3>

          <TypographyV3>
            {t.rich('contact_brand_partnership_body', {
              a(chunks) {
                return (
                  <BodyLinkV3
                    href="https://s.ouraring.com/oura-partners-contact"
                    target="_blank"
                  >
                    {chunks}
                  </BodyLinkV3>
                );
              },
            })}
          </TypographyV3>
        </div>

        <div className="col-main lg:col-end-12 lg:row-start-2 lg:pt-8">
          <TypographyV3 variant="h4" Element="h2">
            {t('contact_section_2_heading')}
          </TypographyV3>
        </div>

        <div className="col-main lg:col-start-13 lg:col-end-main lg:row-start-2 lg:pt-8">
          <TypographyV3 variant="h5" className="mb-8">
            {t('contact_location_info')}
          </TypographyV3>

          <div className="mb-8">
            <TypographyV3>{t.rich('contact_location_address')}</TypographyV3>
          </div>

          <TypographyV3>{t.rich('contact_location_other')}</TypographyV3>
        </div>
      </LayoutGrid>
    </>
  );
};

export default Content;
